import { GridFilterModel } from "@mui/x-data-grid-pro";

import { InvoiceTableFields } from "../hooks/useInvoices";

export type InvoiceAgingBucketKey = `current` | `days_1_30` | `days_31_60` | `days_61_90` | `days_90_plus`;

export interface InvoiceAgingBucket {
  key: InvoiceAgingBucketKey;
  label: string;
  accentColor: string;
  daysOverdueMin?: number;
  daysOverdueMax?: number;
  sortType: `asc` | `desc`;
}

export const invoiceAgingBuckets: InvoiceAgingBucket[] = [
  {
    key: `current`,
    label: `Current`,
    accentColor: `#10B981`,
    daysOverdueMax: 0,
    sortType: `desc`,
  },
  {
    key: `days_1_30`,
    label: `1-30`,
    accentColor: `#EAB308`,
    daysOverdueMin: 1,
    daysOverdueMax: 30,
    sortType: `desc`,
  },
  {
    key: `days_31_60`,
    label: `31-60`,
    accentColor: `#F59E0B`,
    daysOverdueMin: 31,
    daysOverdueMax: 60,
    sortType: `desc`,
  },
  {
    key: `days_61_90`,
    label: `61-90`,
    accentColor: `#F97316`,
    daysOverdueMin: 61,
    daysOverdueMax: 90,
    sortType: `desc`,
  },
  {
    key: `days_90_plus`,
    label: `90+`,
    accentColor: `#EF4444`,
    daysOverdueMin: 91,
    sortType: `desc`,
  },
];

export function invoiceAgingBucketMenuLabel(bucket: InvoiceAgingBucket) {
  return bucket.key === `current` ? bucket.label : `${bucket.label} days`;
}

export function buildInvoiceAgingBucketFilterItems(bucket: Pick<InvoiceAgingBucket, `daysOverdueMin` | `daysOverdueMax`>): GridFilterModel[`items`] {
  // The board buckets only contain unpaid invoices, so pin the status filter to match.
  const items: GridFilterModel[`items`] = [
    {
      field: InvoiceTableFields.invoiceStatus,
      operator: `is`,
      value: `AUTHORISED`,
      id: Math.round(Math.random() * 1e5),
    },
  ];

  if (bucket.daysOverdueMin !== undefined) {
    items.push({
      field: InvoiceTableFields.daysOverdue,
      operator: `>=`,
      value: bucket.daysOverdueMin,
      id: Math.round(Math.random() * 1e5),
    });
  }

  if (bucket.daysOverdueMax !== undefined) {
    items.push({
      field: InvoiceTableFields.daysOverdue,
      operator: `<=`,
      value: bucket.daysOverdueMax,
      id: Math.round(Math.random() * 1e5),
    });
  }

  return items;
}
